export const requiredValidationSlugs = [
  'mandatory_fields',
  'orphaned_mappings',
];
